import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t } from 'i18next';

const ContinueReading = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  const { articlelink, link, description, videolink, documentlink } = location.state || {};

  // Remove 'feed' from the link
  const modifiedLink = articlelink.replace('/feed/', '/');

  const handleBackClick = () => {
    navigate(-1); // Redirects to the previous page
  //    navigate('/feedServices', {
  //   state: { link, description, videolink, documentlink }
  // });
  };

  return (
    <>
  {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
    <button className="win-back-btn" onClick={handleBackClick}>
      <span>
        <i className="bi bi-chevron-left"></i> Back
      </span>
    </button>
    <h2 className="page-heading">Resources</h2>
  </div> */}


{isHighmarkPortal ? 
    <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn" onClick={handleBackClick}>
          <span>
          <i className="bi bi-chevron-left"></i>
          </span>
      </button>       
      <h2 className="page-heading">Resources</h2>
      </div>:
      <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn" onClick={handleBackClick}>
          <span>
          <i className="bi bi-chevron-left"></i>    
          {t('Back')}        
          </span>
      </button>       
      <h2 className="page-heading">Resources</h2>
    </div>
}

<div>
  <iframe
    src={modifiedLink}
    title="Content Viewer"
    style={{
      width: '100%', // Adjusted to fill the parent width
      height: window.innerWidth < 1025 ? '77vh' : '77vh', 
      border: 'none', 
      overflow: 'hidden' // Hides the scrollbar
    }}
    frameBorder="0"
  ></iframe>
</div>
    </>
 
      );
};

export default ContinueReading;